
import axiosInstance from "../Utils/axiosInterceptor";
import {MyLocation} from "../models/Location";


export class LocationService {

    static async getAddressesByKeyword(keyword: string) {
        try {
            const response = await axiosInstance.get<MyLocation[]>("/get_addresses_by_keyword/"+keyword);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async setDriverLocation(location:MyLocation) {
        try {
            const response = await axiosInstance.post<MyLocation[]>("/set_driver_location/",location);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}